import { MainCard } from 'components/CapitalRevamp';
import React from 'react';
import LogoSantaraDark from 'assets/images/backoffice/capital/logo-santara-dark.png';
import styles from '../StatusInvestment.css';

function StatusSantara() {
  return (
    <div className={styles['status-wrapper']}>
      <MainCard border="green" title="Status Pinjaman Anda">
        <div className={styles['status-content']}>
          <img src={LogoSantaraDark} className={styles['logo-santara']} />
          <p className={styles['status-label']}>On Process</p>
        </div>
      </MainCard>
    </div>
  );
}

export default StatusSantara;
